import React from 'react'
import generatingVisualErrorImage from '../../assets/images/generatingvisualerror.svg'
import { useGenerateImages } from '../../services/imageService';
import { useSelector } from 'react-redux';

const GenerateVisualError = () => {

    const generateImages = useGenerateImages();

    const { lastPayload } = useSelector((state) => state.createImage);

    const handleTryAgainButton = () => {
        if (lastPayload) {
            generateImages(
                lastPayload.prompt_id,
                lastPayload.user_prompt,
                {
                    md5: lastPayload.font_id,
                    font_name: lastPayload.fontName,
                    family_url: lastPayload.fontFamilyUrl,
                    foundry_name: lastPayload.foundryName,
                },
            );
        }
    }

    return (
        <div className='bg-[#F3F4F6] w-full h-full'>
            <div className='h-full w-full aspect-[1/1] flexCenter flex-col gap-[40px]'>
                <img src={generatingVisualErrorImage} alt="generating visual error" />
                <div className='flex flex-col gap-[12px]'>
                    <p className='text-cus_primary'>Uh oh! Visual couldn&apos;t be generated.</p>
                    <button onClick={handleTryAgainButton} className='h-[48px] px-[16px] py-[12px] text-pink-primary'>Try again</button>
                </div>
            </div>
        </div>
    )
}

export default GenerateVisualError